import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/ass-2021/sponsors/elf-ad.jpg',
      link: 'https://pioneertheatre.org/',
      alt: 'PTC Elf Annoucment',
      class: 'webFormat',
    },
    {
      image: '/ass-2021/sponsors/pbs.jpg',
      link: 'https://pbsutah.org/',
      alt: 'PBS Utah',
      class: 'webFormat',
    },
    {
      image: '/ass-2021/sponsors/loge-gallery.jpg',
      link: 'https://pioneertheatre.org/loge-gallery',
      alt: 'PTC Loge Gallery Art Also Beings With A',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
